import { LeadInjector } from "../lead/lead-injector.model";

export interface FacebookFormConfiguration {
    id: number,
    formId: string,
    formName: string,
    formDescription: string,
    created: Date,
    updated: Date,
    isEnabled: boolean,
    injector: LeadInjector | null
}

export enum FacebookFormLogsStatus {
    DONE = 'DONE',
    TODO = 'TODO',
    ERROR = 'ERROR'
}

export interface LeadGenerated {
    id: number,
    status: string,
    created: Date,
    formId: string
}

export interface FacebookFormLogs {
    status: FacebookFormLogsStatus,
    updated: Date,
    leads: LeadGenerated[],
    payload: string,
    exception: string | null
}